import { InfiniteFetchableList } from "@/src/components/fetchableLists";
import { IncomeStatus, Patient } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, uid } from "@/src/utils/utils";
import { useState } from "react";
import { IncomeCard } from "./incomeCard";
import { openDrawer } from "@/src/components/dialogs";

function ExistingIncomesList({
  parentId,
  patient,
  statuses,
  emptyChild,
  title,
}: {
  parentId: string;
  patient: Patient;
  statuses: IncomeStatus[];
  emptyChild?: React.ReactNode;
  title?: string;
}) {
  const [searchKey, setSearchKey] = useState("");
  const [reload, setReload] = useState(0);

  return (
    <InfiniteFetchableList
      queryKey={[
        "AccountingPage",
        getItemId(parentId),
        getItemId(patient),
        searchKey,
        reload,
      ]}
      emptyChild={emptyChild}
      limit={100}
      getFunction={(limit, offset, searchKey) => {
        return apiFetch("incomes", "loadMany", {
          startDate: null,
          endDate: null,
          searchKey,
          limit,
          offset,
          parentId,
          statuses: statuses,
          patientId: getItemId(patient),
        });
      }}
    >
      {(data) => {
        return (
          <div className="c1 gap10">
            {title && <div className="bold f16 mtop20">{title}</div>}
            {data?.map((income, index) => {
              return (
                <IncomeCard
                  key={uid()}
                  income={income}
                  searchKey={searchKey}
                  onChange={() => {
                    setReload(reload + 1);
                  }}
                />
              );
            })}
          </div>
        );
      }}
    </InfiniteFetchableList>
  );
}

export async function openExistingIncomesList({
  parentId,
  patient,
  statuses,
}: {
  parentId: string;
  patient: Patient;
  statuses: IncomeStatus[];
}) {
  await openDrawer({
    id: "existingIncomesList",
    title: "Encaissements",
    content: (
      <ExistingIncomesList
        parentId={parentId}
        patient={patient}
        statuses={statuses}
      />
    ),
  });
}

export default ExistingIncomesList;
